<form [formGroup]="detailsForm!" class="auth-form">
  <div class="auth-form__row">
    <div class="auth-field">
      <label>Vorname <span class="auth-field__required">*</span></label>
      <input type="text" placeholder="Dein Vorname" formControlName="first_name" autocomplete="given-name"/>
    </div>
    <div class="auth-field">
      <label>Nachname <span class="auth-field__required">*</span></label>
      <input type="text" placeholder="Dein Nachname" formControlName="last_name" autocomplete="family-name"/>
    </div>
  </div>

  <div class="auth-field">
    <label>Telefonnummer <span class="auth-field__required">*</span></label>
    <input type="tel" placeholder="+49 157 32600116" formControlName="tel" autocomplete="tel"/>
  </div>

  <div class="auth-field">
    <label>Straße und Hausnummer <span class="auth-field__required">*</span></label>
    <input type="text" placeholder="Musterstraße 123" formControlName="street" autocomplete="street-address"/>
  </div>

  <div class="auth-form__row">
    <div class="auth-field">
      <label>Postleitzahl <span class="auth-field__required">*</span></label>
      <input type="text" placeholder="12345" formControlName="postal" autocomplete="postal-code" maxlength="5"/>
    </div>
    <div class="auth-field">
      <label>Stadt <span class="auth-field__required">*</span></label>
      <input type="text" placeholder="Musterstadt" formControlName="city" autocomplete="address-level2"/>
    </div>
  </div>
</form>
